import { useIsMobileViewport } from "@wags/tanstack-start/react";
import { usePreviewedExperiment } from "@/lib/core/experiments/use-experiment-arm";
import { useContactTextKitsPreview } from "./contact-text-kits-preview.ts";

export function useContactTextKits({
    dogName: rawDogName,
    measured,
}: {
    dogName: string | null;
    measured: boolean;
}): { treatment: boolean } {
    const dogName = rawDogName?.trim() || null;
    const isMobileViewport = useIsMobileViewport();
    const preview = useContactTextKitsPreview();
    const arm = usePreviewedExperiment("contact-text-kits", {
        eligible: isMobileViewport && dogName !== null,
        measured,
        preview,
    });
    return { treatment: arm === "treatment" };
}
